import { Blockquote } from "@radix-ui/themes";
import AddBottomSpace from "../../components/AddBottomSpace";
import AddHeadline from "../../components/AddHeadline";
import AddTopSpace from "../../components/AddTopSpace";

export default function Blog() {

  return (
    <>
      <AddTopSpace />
      <AddHeadline />
      <div className="container">

        <div className='row'>
          
          <div className='col-lg-4'>
            <div className="container py-3">
              <div className='row pb-1'>
                <div className='col'>
                  <Blockquote size="6" color>
                    Translocal Inroads
                  </Blockquote>
                </div>
              </div>
            </div>
          </div>
          
          <div className='col-lg-8'>

            <div className="container py-3">
              <div className='row pb-3'>
                <div className='col'>
                  
                </div>
              </div>
              <div className='row pb-3'>
                <div className='col'>
                  
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      
      <AddBottomSpace />
    </>
  )
}
